let portalParentElementSelector: string | null = 'body';
let portalParentElement: Element | null = null;

/**
 * Returns the current portal parent selector string.
 * @public
 * @deprecated Prefer `resolvePortalParent()` which supports both selector strings and direct element references.
 */
export const getPortalParentSelector = (): string => {
  if (portalParentElementSelector) {
    return portalParentElementSelector;
  }
  portalParentElementSelector = 'body';

  return portalParentElementSelector;
};

/**
 * Resolves and returns the portal parent DOM element.
 *
 * Checks for a direct element reference first (set via `setPortalParentElement`),
 * then falls back to querying the DOM with the selector string.
 * This supports Shadow DOM contexts where `document.querySelector` cannot
 * reach elements inside a shadow root.
 *
 * @public
 */
export const resolvePortalParent = (): Element => {
  if (portalParentElement) {
    return portalParentElement;
  }
  const selector = portalParentElementSelector || 'body';
  return document.querySelector(selector) || document.body;
};

/**
 * @private do not export from this package
 */
export const setPortalParentSelector = (selector?: string) => {
  portalParentElementSelector = selector || 'body';
};

/**
 * Sets a direct element reference as the portal parent.
 * Takes priority over the selector string when resolving the portal parent.
 *
 * @private do not export from this package
 */
export const setPortalParentElement = (element?: Element) => {
  portalParentElement = element || null;
};
